const API = process.env.REACT_APP_BACKEND_URL;

// Sprungziel für einen Eintrag der Mandantenansicht (Bereich + ID).
export const zielFuer = (area, id, mnr, caseId) => {
  const q = mnr ? `?mnr=${encodeURIComponent(mnr)}` : '';
  switch (area) {
    case 'dokumente': return { href: `${API}/api/documents/${id}/download` };
    case 'signaturen': return { to: `/kanzlei/mandatsunterlagen${q}` };
    case 'raten': return { to: `/kanzlei/zahlungen/raten${q}` };
    case 'akonto': return { to: `/kanzlei/zahlungen/akonto${q}` };
    case 'sepa': return { to: '/kanzlei/zahlungen?filter=sepa' };
    case 'rueckrufe': return { to: '/team/rueckrufe' };
    case 'termine': return { to: '/kanzlei/termine' };
    case 'notfall': return { to: '/kanzlei/zahlungen/notfall' };
    case 'honorar': return { to: '/kanzlei/eingang' };
    case 'rechnung': return { to: `/kanzlei/zahlungen/rechnungen${q}` };
    default: return caseId ? { to: `/team-portal/${caseId}` } : null;
  }
};

export const oeffnen = (navigate, ziel) => {
  if (!ziel) return;
  if (ziel.href) window.open(ziel.href, '_blank', 'noopener');
  else navigate(ziel.to);
};

export const zeilenKlick = (navigate, ziel) => (e) => {
  if (e.target.closest('button, a, input, select, textarea, [role="menu"]')) return;
  oeffnen(navigate, ziel);
};
